export const countDecimals = (value = "") => {
  const splitted = value.toString().split(".");

  return splitted[1] ? splitted[1].length : 0;
};

export const isValidNumberWithinBoundary = (value, boundary = {}) => {
  const { min = -Infinity, max = Infinity } = boundary;
  const numberValidator = /^[+-]?((\.\d+)|(\d+(\.\d+)?)|(\d+\.))$/;
  const isNumber = numberValidator.test(value);
  const isEmpty = value === "";
  const decimalsCount = countDecimals(value);
  const isWithinBoundaries = (value >= min && value <= max) || isEmpty;
  return !((!isNumber && !isEmpty) || decimalsCount > 2 || !isWithinBoundaries);
};

export const secondsToTime = (seconds) => {
  const secondsToMinute = seconds % (60 * 60);
  const minutesResult = Math.floor(secondsToMinute / 60);

  const secondsInMinute = secondsToMinute % 60;
  const secondsResult = Math.ceil(secondsInMinute);

  return {
    minutes: minutesResult,
    seconds: secondsResult
  };
};
